// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.filter-modal-heading {
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1.5em;
  margin-bottom: 20px;
}
.filter-modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
}

.filter-search {
  width: 100%;
  font-family: "Fivo Sans Light";
  padding: 8px;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: 15px;
  border-width: 1px;
}

.filter-values {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 20px;
}

.filter-value {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.filter-value input {
  margin-right: 10px;
}

.filter-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.filter-modal-action-button {
  margin-left: 10px;
  font-family: "Fivo Sans Regular", sans-serif;
  padding: 10px 20px;
}
.select-options {
  display: flex;
  justify-content: flex-start;
  gap: 3em;
}
.select-action-button {
  font-family: "Fivo Sans light", sans-serif;
  font-size: 0.75em;
  background: none;
  color: #b51f25;
  text-decoration: underline;
}
.select-action-button:active {
  background: none;
}
.checkbox-label {
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.8em;
}
`, "",{"version":3,"sources":["webpack://./src/components/BrowseCollection/FilterModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB","sourcesContent":[".filter-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.filter-modal-heading {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1.5em;\n  margin-bottom: 20px;\n}\n.filter-modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.filter-search {\n  width: 100%;\n  font-family: \"Fivo Sans Light\";\n  padding: 8px;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n  border-radius: 15px;\n  border-width: 1px;\n}\n\n.filter-values {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-top: 20px;\n}\n\n.filter-value {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.filter-value input {\n  margin-right: 10px;\n}\n\n.filter-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.filter-modal-action-button {\n  margin-left: 10px;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  padding: 10px 20px;\n}\n.select-options {\n  display: flex;\n  justify-content: flex-start;\n  gap: 3em;\n}\n.select-action-button {\n  font-family: \"Fivo Sans light\", sans-serif;\n  font-size: 0.75em;\n  background: none;\n  color: #b51f25;\n  text-decoration: underline;\n}\n.select-action-button:active {\n  background: none;\n}\n.checkbox-label {\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.8em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
